import React, { useEffect, useState } from 'react';
import SlimHeader from '../components/SlimHeader';
import MainMenuHeader from '../components/MainMenuHeader';
import MainFooter from '../components/MainFooter';
import { useParams } from 'react-router-dom';

const WrongPayment = (props) => {
  const { mediaQuery } = props.gData;

  const [currentDomain, setCurrentDomain] = useState();

  const { title, price } = useParams();
  const showPrice = parseFloat(price).toFixed(2).split('.');

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const currentDomain = currentUrl.origin;
    setCurrentDomain(currentDomain);

    setTimeout(() => {
      window.location.href = `/myprofile/?domain=${currentDomain}`;
    }, 8000);

    window.scrollTo(0, 0);
  }, []);

  //--- ---

  return (
    <>
      {mediaQuery.isDesktopOrLaptop && <SlimHeader />}
      <MainMenuHeader currentDomain={currentDomain} />

      <div className="container-fluid p-0 bg-white min-h-96">
        <div className="container w-full mx-auto py-9 px-3 sm:px-6 p-0 border-bottom text-primaryLabMar text-md">
          <div className="bg">
            <div className="card">
              <span className="card__error">
                <i className="ion-checkmark"></i>
              </span>

              <h1 className="card__msg">Pagamento non Riuscito</h1>
              <h2 className="card__submsg">
                puoi riprovare ad effettuare il pagamento dalla pagina del tuo profilo personale.
              </h2>

              <div className="card__body">
                <p>{title}</p>
                <h1 className="card__price">
                  <span>€</span>
                  {showPrice[0]}
                  <span>.{showPrice[1]}</span>
                </h1>
              </div>

              <div className="mt-3">
                <a
                  href={`/myprofile/?domain=${currentDomain}`}
                  className="bg-teal-600 font-medium text-md border border-transparent text-white p-4 py-2 rounded-full"
                >
                  torna al profilo
                </a>

                <div className="mt-4 text-blue-gray-600 text-md">oppure attendi il reindirizzamento automatico</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MainFooter />
    </>
  );
};

export default WrongPayment;
